import React, { useState, useEffect, useRef } from "react";
import cn from "classnames";
import styles from './Item.module.sass';
import { Link, useNavigate } from "react-router-dom";

/*
//import Slider from "react-slick";
//import styles from "./Hero.module.sass";
//import Icon from "../../../components/Icon";
//import Player from "../../../components/Player";
//import Modal from "../../../components/Modal";
//import Connect from "../../../components/Connect";
//import { useNavigate } from 'react-router-dom';
// import Bid from "../../../components/Bid";
import API from "../../../utils/API";
import { useSelector } from "react-redux";
// import { FormHelperText } from "@material-ui/core";
*/
import { NAMES_CONSTANTS } from '../../constants';
//import downArrowPng from '../../assets/images/icons/down-arrow.png';
//import realSplitLogoUrl from '../../assets/images/logo/realspilt_logo_white.png';
//import rsLogoUrl from '../../assets/images/logo/RS_icon_white.png';
//import UserHeader from '../../components/Header/UserHeader';
import { numberWithCommas, replaceSpacesWithHyphens } from '../../utils/formatPricingNumber';
/*
const SlickArrow = ({ currentSlide, slideCount, children, ...props }) => (
    <button {...props}>{children}</button>
);
*/

//const PropertyStatistics = (props) => {
//const PropertyStatistics = (productInfo, productDetails, categoryName) => {
const PropertyStatistics = ({
    productInfo
    , productDetails
    //, categoryName
}) => {
    //console.debug('PropertyStatistics(productInfo, productDetails, categoryName)');
    console.debug('PropertyStatistics(productInfo, productDetails)');

    let categoryName = productDetails?.category?.name;

    //console.debug('PropertyStatistics: productInfo = ', productInfo);
    //console.debug('PropertyStatistics: productDetails = ', productDetails);
    //console.debug('PropertyStatistics: categoryName = ', categoryName);

    const navigate = useNavigate();
    /*
    const userAccessToken = localStorage.getItem(NAMES_CONSTANTS.USER_ACCESS_TOKEN);
    console.debug('HeroLoreBuilding: userAccessToken = ', userAccessToken);

    const sliderRef = useRef();

    let [assets, setAssets] = useState([]);

    useEffect(() => {
        console.debug('HeroLoreBuilding: useEffect(() => {');
        console.debug('    props.assets = ', props.assets);

        setAssets(props.assets);
    }, []);

    const [data, setData] = useState([]);
    const [timeArr, setTimeArr] = useState(null);

    function timeLeft(item) {
        if (item?.auction?.endingDate) {
            var now = new Date();
            var diff = new Date(item?.auction?.endingDate) - now;
            var hours = Math.floor(diff / 3.6e6);
            var minutes = Math.floor((diff % 3.6e6) / 6e4);
            var seconds = Math.floor((diff % 6e4) / 1000);
            if (hours < 0 || minutes < 0 || seconds < -1) {
              return { hours: 0, minutes: 0, seconds: 0 }
            }
            return { hours, minutes, seconds }
        }
        return { hours: 0, minutes: 0, seconds: 0 }
    }

    useEffect(() => {

        let params = {
            limit: 20,
            page: 1,
            saleType: "auction"
        };

        //getSliderAuctions(params);

        const getAllData = setInterval(() => {
          setTimeArr(data.map(item => timeLeft(item.item)));
        }, 1000);

        return () => clearInterval(getAllData);

    }, [])

    const clickLearnMore = () => navigate('/item/1');
    */
          
    return ( <>

        <div className={ "item-details" }>

        <div
            id='product-info'
            className = {
                cn(
                    "item-details-table-wrapper"
                    , styles.tabbedProductDescription
                )
            }
            //style = {{
            //     borderRadius: '10px'
            //    , border: '1px solid var(--color-gray-300, #DEE2E6)'
            //    , background: 'var(--White, #FFF)'
                /*
                , background: (
                    productDetails.status == 'past-deal'
                    ? 'var(--color-gray-200)'
                    : 'var(--White, #FFF)'
                )
                , color: (
                    productDetails.status == 'past-deal'
                    ? 'var(--color-gray-600)'
                    : 'var(--color-gray-700)'
                )
                */
            //}}
            >

            {/*
            <div className={ "table body" }>
            */}
            <div
                className = { cn(
                    'table'
                    , 'item-details-table'
                    , styles.tableBody
                )}
                >

                <div className={'row'}>

                    <div
                        className = 'cell icon'
                        //style = {{ paddingLeft: "20px" }}
                        >
                        <img
                            //src = '/images/icons/building.svg'
                            //src = '/images/icons/svgrepo/building-business-management-svgrepo-com.svg'
                            src = '/images/icons/tags-icon-black.png'
                            //className = { "filter-body-text-color" }
                            className = 'filter-body-text-color'
                            //style = {{ fill: "red" }}
                            />
                    </div>

                    <div
                        className = 'cell label'
                        //dataShortName = 'Asset Category'
                        //data-short-name = 'Asset Category'
                        //dataLongName = 'Asset Category'
                        //data-long-name = 'Asset Category'
                        >
                        {/*
                        Asset Category
                        Category
                          */}
                        <span className = 'long-name'>
                            Asset Category
                        </span>
                        <span className = 'short-name'>
                            Category
                        </span>
                    </div>

                    <div
                        className = {
                            cn(
                                'cell'
                                //, categoryName
                            )
                        }
                        style = {{
                              color: 'var(--color-gray-800, #343A40)'
                            , fontFamily: 'Source Sans 3'
                            , fontSize: '16px'
                            , fontStyle: 'normal'
                            , fontWeight: '700' 
                        }}
                        >

                        <div
                            className = {
                                cn(
                                    "item"
                                    //, categoryName
                                    , styles.item
                                )
                            }
                            //className = { cn("item", "industrial", styles.item)}
                            onClick = { () => navigate("/search/" + categoryName) }
                            //onClick = { () => clickCategory(getCategoryName(x?.asset.categoryId)) }
                            style = {{
                                //display: 'absolute'
                                position: 'relative'
                                //, right: '0'
                            }}>

                            <div
                                //className = { categoryName }
                                //className = { cn(categoryName, 'text-shadow') }
                                style = {{
                                    //display: 'absolute'
                                    position: 'absolute'
                                    , right: '0'
                                    //, top: '-16px'
                                    , bottom: '-16px'
                                    , whiteSpace: 'nowrap'
                                }}
                                >

                                {
                                    //productInfo?.isResell
                                    productInfo?.status
                                    //&& <div
                                    ? <div
                                        style = {{
                                            //color: 'white'
                                            display: 'flex'
                                            //, marginLeft: '8px'
                                            , margin: 'auto'
                                            //, position: 'absolute'
                                            //, right: '0'
                                            //, top: '-40px'
                                            //, border: 'red 1px solid'
                                            , textAlign: 'center'
                                        }}>
                                        <div
                                            className = {
                                                cn(
                                                    'flag-tag'
                                                    //, productInfo?.status
                                                    , replaceSpacesWithHyphens(productInfo?.status)
                                                )
                                            }
                                            style = {{
                                                  padding: '3px 8px'
                                                , fontSize: '14px'
                                                , fontWeight: '500'
                                                , margin: 'auto'
                                                , borderWidth: '2px 2px 0px 2px'
                                                , borderTopLeftRadius: '5px'
                                                , borderTopRightRadius: '5px'
                                                /*
                                                , verticalAlign: 'top'
                                                , fontFamily: 'DM Sans'
                                                , textAlign: 'center'
                                                , textTransform: 'none'
                                                //, border: 'red 2px solid'
                                                
                                                //, color: 'red'
                                                //, color: 'green'
                                                , color: 'white'
                                                //, backgroundColor: 'white'
                                                , backgroundColor: 'green'
                                                , boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.5)'
                                                */
                                            }}
                                            >
                                            { productInfo?.status }
                                        </div>
                                    </div>

                                    : <div
                                        style = {{
                                            //color: 'white'
                                            display: 'flex'
                                            //, marginLeft: '8px'
                                            , margin: 'auto'
                                            //, position: 'absolute'
                                            //, right: '0'
                                            //, top: '-40px'
                                            //, border: 'red 1px solid'
                                            , textAlign: 'center'
                                        }}>

                                        {
                                            productDetails?.saleType == 'past-deal' || productDetails?.status == 'past-deal'
                                            ? <div
                                                className = {
                                                    cn(
                                                        'flag-tag'
                                                        , 'Available'
                                                        , productInfo?.saleType
                                                        //, productInfo?.status
                                                        , replaceSpacesWithHyphens(productInfo?.status)
                                                    )
                                                }
                                                /*
                                                style = {{
                                                      padding: '3px 8px'
                                                    , fontSize: '16px'
                                                    , fontWeight: '500'
                                                    , verticalAlign: 'top'
                                                    , fontFamily: 'DM Sans'
                                                    , textAlign: 'center'
                                                    , textTransform: 'none'
                                                    , border: 'red 2px solid'
                                                    , borderWidth: '2px 2px 0px 2px'
                                                    , backgroundColor: 'white'
                                                    , borderTopLeftRadius: '5px'
                                                    , borderTopRightRadius: '5px'
                                                    , margin: 'auto'
                                                    , color: 'red'
                                                    , boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.5)'
                                                }}
                                                */
                                                >
                                                Past Deal
                                            </div>
                                            : <div
                                                className = {
                                                    cn(
                                                        'flag-tag'
                                                        , 'Available'
                                                        , productInfo?.saleType
                                                        //, productInfo?.status
                                                        , replaceSpacesWithHyphens(productInfo?.status)
                                                    )
                                                }
                                                /*
                                                style = {{
                                                      padding: '3px 8px'
                                                    , fontSize: '16px'
                                                    , fontWeight: '500'
                                                    , verticalAlign: 'top'
                                                    , fontFamily: 'DM Sans'
                                                    , textAlign: 'center'
                                                    , textTransform: 'none'
                                                    //, border: 'red 2px solid'
                                                    //, borderWidth: '2px 2px 0px 2px'
                                                    , backgroundColor: 'white'
                                                    , borderTopLeftRadius: '5px'
                                                    , borderTopRightRadius: '5px'
                                                    , margin: 'auto'
                                                    //, color: 'green'
                                                    , color: 'white'
                                                    //, backgroundColor: 'white'
                                                    , backgroundColor: 'green'
                                                    , boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.5)'
                                                }}
                                                */
                                                >
                                                Available
                                            </div>
                                        }

                                    </div>
                                }

                                <button
                                    className = { cn(categoryName, 'text-shadow') }
                                    style = {{
                                        boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.5)'
                                    }}
                                    >
                                    { categoryName }
                                </button>

                            </div>

                        </div>

                    </div>
                </div>

                {/*
                <div className = 'row'>
                    <div className = 'cell icon'>
                        <img
                            //src='/images/icons/graph-up.svg'
                            src = '/images/icons/svgrepo/business-folder-management-svgrepo-com.svg'
                            />
                    </div>
                    <div className = 'cell label'>
                        % Owned
                        % Already Pre-Owned
                    </div>
                    <div className={'cell'}>
                        { productInfo.percentageOwned }
                    </div>
                </div>

                <div className = 'row'>
                    <div className = 'cell icon'>
                        <img
                            //src='/images/icons/graph-up.svg'
                            src = '/images/icons/svgrepo/business-folder-management-svgrepo-com.svg'
                            />
                    </div>
                    <div className = 'cell label'>
                        % Available to RealSplit
                    </div>
                    <div className={'cell'}>
                        { productInfo.percentageAvailable 
                    </div>
                </div>
                */}

                {
                    (
                        productDetails?.saleType == 'past-deal'
                        || productDetails?.status == 'past-deal'
                    ) && !productInfo?.isResell
                    
                    ? <>

                        <div className = 'row'>
                            <div className = 'cell icon'>
                                <img src = '/images/icons/dollar-sign-transparent.png' />
                            </div>
                            <div className = 'cell label'>
                                <div>
                                    <span className = 'long-name'>
                                        Purchase Price
                                    </span>
                                    <span className = 'short-name'>
                                        Price
                                    </span>
                                </div>
                            </div>
                            <div className = { 'cell' }>
                                { productDetails?.investmentSize }
                            </div>
                        </div>

                        {
                            productDetails.soldFor
                            && <div className = 'row'>
                                <div className = 'cell icon'>
                                    <img src = '/images/icons/dollar-sign-transparent.png' />
                                </div>
                                <div className = 'cell label'>
                                    <div>
                                        <span className = 'long-name'>
                                            Sale Price
                                        </span>
                                        <span className = 'short-name'>
                                            Sale Price
                                        </span>
                                    </div>
                                </div>
                                <div className = { 'cell' }>
                                    { productDetails.soldFor }
                                </div>
                            </div>
                        }

                        {
                            productDetails.dateSold
                            && <div className = 'row'>
                                <div className = 'cell icon'>
                                    <img
                                        src = '/images/icons/calendar-icon.png'
                                        />
                                </div>
                                <div className = 'cell label'>
                                    <div>
                                        <span className = 'long-name'>
                                            Date Sold
                                        </span>
                                        <span className = 'short-name'>
                                            Date Sold
                                        </span>
                                    </div>
                                </div>
                                <div className = { 'cell' }>
                                    { productDetails.dateSold }
                                </div>
                            </div>
                        }

                        {
                            productDetails.valueToday
                            && <div className = 'row'>
                                <div className = 'cell icon'>
                                    <img src = '/images/icons/dollar-sign-transparent.png' />
                                </div>
                                <div className = 'cell label'>
                                    <div>
                                        <span className = 'long-name'>
                                            Value Today
                                        </span>
                                        <span className = 'short-name'>
                                            Value Today
                                        </span>
                                    </div>
                                    <div className = 'long-name'>
                                        Currently own and operate
                                    </div>
                                </div>
                                <div className = { 'cell' }>
                                    { productDetails.valueToday }
                                </div>
                            </div>
                        }

                        {/*
                        <div className = { "row" }>
                            <div className = { "cell" }>
                                Original Purchase Price:
                            </div>
                            <div className = { "cell" }>
                                { productDetails?.purchasePrice }
                            </div>
                        </div>
                        */}

                        <div className = 'row'>
                            <div className = 'cell icon'>
                                <img
                                    //src='/images/icons/graph-up.svg'
                                    //src = '/images/icons/svgrepo/business-grafik-management-svgrepo-com.svg'
                                    //src = '/images/icons/return-on-investment-icon.png'
                                    //src = '/images/icons/bar-chart-up-3.svg'
                                    src = '/images/icons/noun-increase-212057-cropped.png'
                                    />
                            </div>
                            <div className = 'cell label'>
                                <div>
                                    <span className = 'long-name'>
                                        Return on Investment
                                    </span>
                                    <span className = 'short-name'>
                                        Return
                                    </span>
                                </div>
                                <div
                                    className = 'long-name'
                                    //style = {{ fontSize: '.6em', lineHeight: '12px', margin: '4px 0px', textTransform: 'none' }}
                                    >
                                    Annualized based on a 5-year hold
                                </div>
                            </div>
                            <div className = { 'cell' }>
                                { productDetails?.returnOnInvestment }
                            </div>
                        </div>
                    </>

                    : <>
                        {
                            productDetails?.percentageOwned != null
                            && productDetails?.percentageOwned !== 0.0
                            && productDetails?.percentageOwned !== 'N/A'
                            && <> 
                                <div className = 'row'>
                                    <div className = 'cell icon'>
                                        <img
                                            //src='/images/icons/graph-up.svg'
                                            //src = '/images/icons/svgrepo/business-folder-management-svgrepo-com.svg'
                                            //src = '/images/icons/98913.png'
                                            //src = '/images/icons/percentage-sign.png'
                                            //src = '/images/icons/percentage-owned.png'
                                            //src = '/images/icons/fractions-available.png'
                                            //src = '/images/icons/percentage-owned.png'
                                            src = '/images/icons/fractions-available.png'
                                            style = {{ transform: 'rotate(180deg)' }}
                                            />
                                    </div>
                                    <div className = 'cell label'>
                                        <div>
                                            <span className = 'long-name'>
                                                % Already Pre-Owned
                                            </span>
                                            <span className = 'short-name'>
                                                % Pre-Owned
                                            </span>
                                        </div>
                                        <div className = 'long-name'
                                            //style = {{ fontSize: '.6em', lineHeight: '12px', margin: '4px 0px', textTransform: 'none' }}
                                            >
                                            {/*
                                            The percentage of the property that is owned by the current owners.
                                            The percentage of the deal that will remain owned by the current owners.
                                            */}
                                            The percentage of the property that is currently owned and that will remain owned by the current owners
                                        </div>
                                    </div>
                                    <div className = { 'cell' }>
                                        {
                                            productDetails.percentageOwned != null && productDetails.percentageOwned !== 0.0
                                            ? productDetails.percentageOwned
                                            : 'N/A'
                                        }
                                    </div>
                                </div>

                                <div className = 'row'>
                                    <div className = 'cell icon'>
                                        <img
                                            //src='/images/icons/graph-up.svg'
                                            //src = '/images/icons/svgrepo/business-folder-management-svgrepo-com.svg'
                                            //src = '/images/icons/percentage-sign.png'
                                            //src = '/images/icons/fractions-available.png'
                                            //src = '/images/icons/fractions-available.png'
                                            src = '/images/icons/percentage-owned.png'
                                            />
                                    </div>
                                    <div className = 'cell label'>
                                        <div>
                                            <span className = 'long-name'>
                                                % Available for Fractionalization
                                            </span>
                                            <span className = 'short-name'>
                                                % Available
                                            </span>
                                        </div>
                                        <div
                                            className = 'long-name'
                                            //style = {{ fontSize: '.6em', lineHeight: '12px', margin: '4px 0px', textTransform: 'none' }}
                                            >
                                            {/*
                                            The percentage of the deal that is available for fractionalized ownership by RealSplit™ investors
                                            */}
                                            The percentage of the property that is available for fractionalized ownership by RealSplit™ investors
                                        </div>
                                    </div>
                                    <div className = { 'cell' }>
                                        { productDetails?.percentageAvailable }
                                    </div>
                                </div>
                            </> 
                        }

                        {
                            !productInfo?.isResell
                            && productDetails?.investmentSize
                            && <div className = 'row'>
                                <div className = 'cell icon'>
                                    <img
                                        //src='/images/icons/graph-up.svg'
                                        //src = '/images/icons/svgrepo/business-folder-management-svgrepo-com.svg'
                                        //src = '/images/icons/1819867-200.png'
                                        src = '/images/icons/dollar-sign-transparent.png'
                                        />
                                </div>
                                <div className = 'cell label'>
                                    <div>
                                    <span className = 'long-name'>
                                        Investment Size
                                    </span>
                                    <span className = 'short-name'>
                                        Size
                                    </span>
                                    </div>

                                    <div
                                        className = 'long-name'
                                        >
                                        {/*
                                        */}
                                        The total amount of capital to be raised
                                    </div>
                                </div>
                                <div className = { 'cell' }>
                                    { productDetails?.investmentSize }
                                </div>
                            </div>
                        }

                        {
                            productInfo?.availableFractions > 0
                            &&
                                <div className = 'row'>
                                    <div className = 'cell icon'>
                                        <img
                                            src = '/images/icons/dollar-sign-transparent.png'
                                            //style = {{ transform: 'rotate(90deg)' }}
                                            />
                                    </div>
                                    <div className = 'cell label'>

                                        {
                                            productInfo?.isResell
                                            ? <div>
                                                <span className = 'long-name'>
                                                    Amount Available
                                                </span>
                                                <span className = 'short-name'>
                                                    Available
                                                </span>
                                            </div>
                                            : <div>
                                                <span className = 'long-name'>
                                                    Amount Remaining
                                                </span>
                                                <span className = 'short-name'>
                                                    Remaining
                                                </span>
                                            </div>
                                        }

                                        <div
                                            className = 'long-name'
                                            //style = {{ fontSize: '.6em', lineHeight: '12px', margin: '4px 0px', textTransform: 'none' }}
                                            >
                                            The amount of capital remaining to be raised and available to RealSplit investors
                                        </div>
                                    </div>
                                    <div className = { 'cell' }>
                                        {/*
                                        ${
                                            numberWithCommas(productInfo?.availableFractions * productDetails?.regularPrice)//.toFixed(CRYPTOCURRENCY_CONSTANTS.CRYPTO_PRICE_DECIMAL_PLACES))
                                        }
                                        */}
                                        ${
                                            productInfo?.availableFractions == 0
                                            ? 
                                                0
                                            :
                                                numberWithCommas(productInfo?.availableFractions * productDetails?.regularPrice)//.toFixed(CRYPTOCURRENCY_CONSTANTS.CRYPTO_PRICE_DECIMAL_PLACES))
                                        }
                                    </div>
                                </div>
                        }

                        {/*
                            productDetails?.minimumInvestmentAmount
                            &&
                                <div className = 'row'>
                                    <div className = 'cell icon'>
                                        <img
                                            //src='/images/icons/graph-up.svg'
                                            //src = '/images/icons/svgrepo/business-folder-management-svgrepo-com.svg'
                                            src = '/images/icons/dollar-sign-transparent.png'
                                            />
                                    </div>
                                    <div className = 'cell label'>
                                        <div>
                                            <span className = 'long-name'>
                                                Minimum Investment Amount
                                            </span>
                                            <span className = 'short-name'>
                                                Minimum
                                            </span>
                                        </div>
                                        <div
                                            className = 'long-name'
                                            //style = {{ fontSize: '.6em', lineHeight: '12px', margin: '4px 0px', textTransform: 'none' }}
                                            >
                                            { productDetails?.minimumInvestment / productDetails?.regularPrice } Split{
                                                (productDetails?.minimumInvestment / productDetails?.regularPrice) > 1
                                                && (
                                                    's'
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className = { 'cell' } style = {{ whiteSpace: 'nowrap' }}>
                                        { productDetails?.minimumInvestmentAmount }
                                    </div>
                                </div>
                        */}

                        {/*
                        <div className = 'row'>
                            <div className = 'cell icon'>
                                <img
                                    //src='/images/icons/graph-up.svg'
                                    src = '/images/icons/svgrepo/business-folder-management-svgrepo-com.svg'
                                    />
                            </div>
                            <div className = 'cell label'>
                                <span className = 'long-name'>
                                    Total Splits
                                </span>
                                <span className = 'short-name'>
                                    Total Splits Available
                                </span>
                            </div>
                            <div className = {' cell' }>
                                { productInfo.totalFractions }
                            </div>
                        </div>
                        */}

                        {/* 
                        <div className = 'row'>
                            <div className = 'cell icon'>
                                <img
                                    //src='/images/icons/graph-up.svg'
                                    src = '/images/icons/svgrepo/business-folder-management-svgrepo-com.svg'
                                    />
                            </div>
                            <div className = 'cell label'>
                                Splits Remaining
                            </div>
                            <div className={'cell'}>
                                { productInfo.availableFractions }
                            </div>
                        </div>
                        */}

                        {
                            productInfo?.totalFractions > 0
                            &&
                                <>
                                <div className = 'row'>
                                    <div className = 'cell icon'>
                                        <img
                                            //src='/images/icons/graph-up.svg'
                                            //src = '/images/icons/black-pie-chart-75-percent-15676.png'
                                            //src = '/images/icons/fractions-available.png'
                                            src = '/images/icons/six-fractions.png'
                                            //src = '/images/icons/black-pie-chart-75-percent-15676.png'
                                            //style = {{ transform: 'rotate(90deg)' }}
                                            />
                                    </div>
                                    <div className = 'cell label'>
                                        <div>
                                            <span className = 'long-name'>
                                                Total Splits Available
                                            </span>
                                            <span className = 'short-name'>
                                                Total Splits
                                            </span>
                                        </div>
                                        <div
                                            className = 'long-name'
                                            //style = {{ fontSize: '.6em', lineHeight: '12px', margin: '4px 0px', textTransform: 'none' }}
                                            >
                                            {/*
                                            (calculated by dividing the size of the deal by the price per fraction)
                                            The total amount of Splits available to RealSplit™ investors
                                            */}
                                            The total amount of Splits available in this deal <br/>INVESTMENT SIZE divided by COST PER SPLIT
                                        </div>
                                    </div>
                                    <div className = { 'cell' }>
                                        { productInfo?.totalFractions }
                                    </div>
                                </div>

                                <div className = 'row'>
                                    <div className = 'cell icon'>
                                        <img
                                            //src='/images/icons/graph-up.svg'
                                            //src = '/images/icons/black-pie-chart-75-percent-15676.png'
                                            //src = '/images/icons/six-fractions-one-taken.png'
                                            src = '/images/icons/six-fractions-two-taken.png'
                                            //src = '/images/icons/fractions-available.png'
                                            //style = {{ transform: 'rotate(90deg)' }}
                                            />
                                    </div>
                                    <div className = 'cell label'>
                                        <div>
                                            <span className = 'long-name'>
                                                Splits Remaining
                                            </span>
                                            <span className = 'short-name'>
                                                Available
                                            </span>
                                        </div>
                                        <div
                                            className = 'long-name'
                                            //style = {{ fontSize: '.6em', lineHeight: '12px', margin: '4px 0px', textTransform: 'none' }}
                                            >
                                            Splits remaining to be sold (available to be bought) by RealSplit investors
                                        </div>
                                    </div>
                                    <div className = { 'cell' }>
                                        { productInfo?.availableFractions }
                                    </div>
                                </div>
                                </>
                        }

                        {
                            !productInfo?.isResell
                            && productDetails?.closingDate
                            && <div
                                className = { 'row' }
                                //style = {{ display: 'none' }}
                                >

                                <div
                                    className={'cell icon'}
                                    //style = {{ padding: "0px 20px" }}
                                    >
                                    <img
                                        //src='/images/icons/clock.svg'
                                        //src = '/images/icons/svgrepo/clock-v-svgrepo-com.svg'
                                        //src = '/images/icons/time-schedule-clock-svgrepo-com.png'
                                        src = '/images/icons/calendar-icon.png'
                                        />
                                </div>

                                <div className = {
                                    cn(
                                          'cell'
                                        , 'label'
                                        //, styles.label
                                    )
                                    }>
                                    <span className = 'long-name'>
                                        Investment Deadline
                                    </span>
                                    <span className = 'short-name'>
                                        Deadline
                                    </span>
                                </div>

                                <div
                                    //className = { cn('cell', 'bold') }
                                    className = 'cell'
                                    //style = {{
                                    //    textTransform: "capitalize"
                                    //}}
                                    >

                                    {
                                        productDetails?.status != 'past-deal'
                                        ?
                                            <div style = {{
                                                display: 'flex'
                                                //, flexWrap: 'wrap'
                                                //, flexDirection: 'row'
                                                , justifyContent: 'flex-end'
                                                , flexWrap: 'nowrap'
                                                , flexDirection: 'column'
                                                }}>

                                                <div
                                                    style = {{
                                                        whiteSpace: 'nowrap'
                                                        , fontSize: '66%'
                                                        , fontWeight: 'normal'
                                                        , color: 'var(--color-gray-600)'
                                                        , textTransform: "initial"
                                                        , lineHeight: '20px'
                                                    }}>
                                                    
                                                    ({
                                                        // Check if the closing date is in the past or future
                                                        new Date() > new Date(Date.parse(productDetails?.closingDate))

                                                        ? [ // "Past"
                                                            Math.round(
                                                                  Number(
                                                                        new Date().getTime()
                                                                      - new Date(Date.parse(productDetails?.closingDate)).getTime()
                                                                  ) / (1000 * 60 * 60 * 24)
                                                            )
                                                            , "Days ago"
                                                        ].join(' ')

                                                        : [ // "Future"
                                                            Math.round(
                                                                  Number(
                                                                        new Date(Date.parse(productDetails?.closingDate)).getTime()
                                                                      - new Date().getTime()
                                                                  ) / (1000 * 60 * 60 * 24)
                                                            )
                                                            , "Days"
                                                        ].join(' ')
                                                    })
                                                </div>

                                                <div
                                                    style = {{
                                                        whiteSpace: 'nowrap'
                                                        , lineHeight: '30px'
                                                    }}
                                                    >
                                                    &nbsp;
                                                    { 
                                                        new Date(
                                                            Date.parse(productDetails?.closingDate)
                                                        )
                                                        .toLocaleDateString(
                                                            "en-US"
                                                            //, { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' }
                                                            //, { year: 'numeric', month: 'long', day: 'numeric' }
                                                            , { year: 'numeric', month: 'short', day: 'numeric' }
                                                        )
                                                    }
                                                </div>

                                            </div>
                                        :
                                            <div>
                                                CLOSED
                                            </div>
                                    }

                                </div>
                            </div>
                        }

                        {/*
                        {
                            productDetails?.holdingPeriod != null
                            && <div className = 'row'>
                                <div className = 'cell icon'>
                                    <img
                                        //src = '/images/icons/calendar2.svg'
                                        //src = '/images/icons/svgrepo/business-calendar-management-svgrepo-com.svg'
                                        src = '/images/icons/png-clipart-padlock-computer-icons-security-padlock-technic-logo-thumbnail.png'
                                        />
                                </div>
                                <div className = 'cell label'>
                                    <span className = 'long-name'>
                                        Holding Period
                                    </span>
                                    <span className = 'short-name'>
                                        Holding
                                    </span>
                                </div>
                                <div className = { 'cell' }>
                                    { productDetails.holdingPeriod }
                                </div>
                            </div>
                        }
                        */}

                        {/*
                        <div className = 'row'>
                            <div className = 'cell icon'>
                                <img
                                    //src='/images/icons/people.svg'
                                    //src='/images/icons/svgrepo/business-management-media-7-svgrepo-com.svg'
                                    //src='/images/icons/connected-people-icon.svg'
                                    src='/images/icons/referred-affiliates-1.png'
                                    />
                            </div>
                            <div
                                //className = { cn('cell', styles.label) }
                                className = 'cell label'
                                >
                                Investors
                                Current Investors in deal
                            </div>
                            <div className={'cell'}>
                                0
                            </div>
                        </div>
                        */}

                        {
                            productDetails?.returnOnInvestment
                            &&
                                <div className = 'row'>
                                    <div className = 'cell icon'>
                                        <img
                                            //src='/images/icons/graph-up.svg'
                                            //src = '/images/icons/svgrepo/business-grafik-management-svgrepo-com.svg'
                                            //src = '/images/icons/return-on-investment-icon.png'
                                            //src = '/images/icons/bar-chart-up-3.svg'
                                            src = '/images/icons/noun-increase-212057-cropped.png'
                                            />
                                    </div>
                                    <div className = 'cell label'>
                                        {/*
                                        ROI
                                        */}
                                        <div>
                                            <span className = 'long-name'>
                                                Return on Investment
                                            </span>
                                            <span className = 'short-name'>
                                                Return
                                            </span>
                                        </div>
                                        <div
                                            className = 'long-name'
                                            //style = {{ fontSize: '.6em', lineHeight: '12px', margin: '4px 0px', textTransform: 'none' }}
                                            >
                                            Annualized based on 5-year hold
                                        </div>
                                    </div>
                                    <div className = { 'cell' }>
                                        { productDetails?.returnOnInvestment }
                                    </div>
                                </div>
                        }

                        {/*
                        <div className={'row'}>
                            <div className={'cell'}>
                                <img src='/images/icons/svgrepo/asset-management-icon.svg' />
                            </div>
                            <div className={cn('cell', styles.label)}>
                                Price
                            </div>
                            <div className={'cell'}>
                                ${displayPrice(productInfo, exchangeRate)} ({displayCryptoPrice(productInfo)} Matic)
                            </div>
                        </div>
                        
                        <div className={'row'}>
                            <div className={cn('cell', styles.label)}>
                                Total Editions
                            </div>
                            <div className={'cell'}>{ productInfo?.asset?.totalEdition }</div>
                        </div>

                        <div className={'row'}>
                            <div className={cn('cell', styles.label)}>
                                Editions left in this Asset
                            </div>
                            <div className={'cell'}>{ productInfo?.asset?.availableStock }</div>
                        </div>

                        <div className={'row'}>
                            <div className={cn('cell', styles.label)}>
                                Creator
                            </div>
                            <div className={'cell'}>{productDetails?.creatorName}</div>
                        </div>
                        */}

                    </>
                }

            </div>
        </div>
        </div>
    </>);
};

export default PropertyStatistics;
